<template>
    <MasterTemplate 
        title="ข้อมูลรุ่น" 
        :headers="headers" 
        :setData="setData"
        itemKey="modelId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="4" >
                    <v-text-field label="รหัสรุ่น" autofocus maxlength="20" v-model="editedItem.modelCode" :rules="[rules.required, chkCode]"></v-text-field>
                </v-col>
                <v-col cols="8" >
                    <v-text-field  label="ชื่อรุ่น" maxlength="100" v-model="editedItem.modelName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" >
                    <v-select
                        v-model="editedItem.brandCode"
                        :items="brands"
                        label="ยี่ห้อ"
                        item-text="name"
                        item-value="value"
                    ></v-select>
                </v-col>
            </v-row>

        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listModel, isExistModelCode, insertModel, updateModel, deleteModel} from '@/api/master/model-api.js'
import {listDropdownBrand} from '@/api/common/dropdown-api.js'

export default {
    name: 'Model',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (this.isDup == true) return 'รหัสรุ่นซ้ำ';
            return true;
        }
    },
    watch: {
        'editedItem.modelCode': function(newVal) {
            if (!this.editedItem.modelId) {
                this.editedItem.modelId = '-1';
            }
            if (newVal && this.editedItem.modelId) {
                isExistModelCode(newVal, this.editedItem.modelId).then(response => {
                    this.isDup = response;
                }).catch(() => {
                    this.isDup = false;
                });
            }
        }
    },
    data: () => ({
        isDup: false,
        headers: [
            {text: 'รหัสรุ่น', value: 'modelCode'},
            {text: 'ชื่อรุ่น', value: 'modelName'},
            {text: 'ยี่ห้อ', value: 'brandName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            modelId: '-1',
            modelCode: '',
            brandCode: ''
        },
        brands: []
    }),
    methods: {
        listData() {
            return listModel();
        },
        deleteData(item) {
            return deleteModel(item.modelId);
        },
        insertData() {
            return insertModel(this.editedItem);
        },
        updateData() {
            return updateModel(this.editedItem);
        },
        getItemName(item) {
            return item.modelName;
        },
        setData(item) {
            this.editedItem = item;
        }
    },
    mounted() {
        listDropdownBrand().then(rs => {
            console.log(rs);
            this.brands = rs.data
        });
    }
}
</script>
